import { ServerConfig } from '@superbet-group/web.lib.config';

export const betlerPolandCmsOverride: DeepPartial<ServerConfig> = {
};
